import React from "react";
import { Form } from "rsuite";
import styled from "styled-components";

import s from "./CustomField.module.css";

export default class extends React.PureComponent {
    render() {
        const { name, message, label, error, inline = false, formValue = null, formGroupClassName = null, ...props } = this.props;
        let formGroupClasses = [];

        if (error) {
            formGroupClasses.push("has-error");
        }

        if (inline) {
            formGroupClasses.push(s.inline);
        }

        if (formGroupClassName) {
            formGroupClasses.push(formGroupClassName);
        }


        return (
            <StyledFormGroup className={formGroupClasses.join(" ")}>
                {
                    (() => label ? <Form.ControlLabel className={s.label}>{label}</Form.ControlLabel> : <></>)()
                }
                <div className={s.field}>
                    <Form.Control
                        className={s.input}
                        name={name}
                        errorMessage={error}
                        {...props}
                    />
                </div>
                {(() => message ? <Form.HelpText>{message}</Form.HelpText> : <></>)()}
            </StyledFormGroup>
        )
    };
};

const StyledFormGroup = styled(Form.Group)`
    && {
        .custom-field__icon {
            position: absolute;
            right: 10px;
        }
        .rs-icon {
            color: var(--color-green);
        }
    }
`;
